export default {
  aw: {
    enableFrom: '2025-01-01',
    cover: 'https://cdn.eventtia.com/event_files/227680/original/venues4.png?1768592167',
    categoryId: '111297',
    title: 'AWARDS WEEK',
  },
  /* Ask backend for hack to show the categories */
  displayAll: {
    enableFrom: '2025-05-21',
    cover: 'https://cdn.eventtia.com/event_files/203132/original/may20.jpg?1736442720',
    categoryId: '143268',
  },

  jun08: {
    enableFrom: '2025-05-22',
    cover: 'https://cdn.eventtia.com/event_files/227681/original/venues5.png?1768592180',
    categoryId: '111299',
    title: 'Mon 08 June',
    topText: 'Mon',
    mainText: '08',
    bottomText: 'June',
  },
  jun09: {
    enableFrom: '2025-05-23',
    cover: 'https://cdn.eventtia.com/event_files/227677/original/venues1.png?1768591775',
    categoryId: '111300',
    title: 'Tue 09 June',
    topText: 'Tue',
    mainText: '09',
    bottomText: 'June',
  },
  jun10: {
    enableFrom: '2025-05-24',
    cover: 'https://cdn.eventtia.com/event_files/227678/original/venues2.png?1768591891',
    categoryId: '111301',
    title: 'Wed 10 June',
    topText: 'Wed',
    mainText: '10',
    bottomText: 'June',
  },
  jun11: {
    enableFrom: '2025-05-25',
    cover: 'https://cdn.eventtia.com/event_files/227683/original/venues7.png?1768592206',
    categoryId: '111302',
    title: 'Thu 11 June',
    topText: 'Thu',
    mainText: '11',
    bottomText: 'June',
  },
};
